import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IonList, IonItem, IonLabel, IonIcon } from '@ionic/react';
import { chevronForward } from 'ionicons/icons';
import PromotionModal from '../PromotionModal';

function PromotionList({ promotions }) {
  const [active, setActive] = useState(null);
  return (
    <IonList>
      {promotions.map((r) => {
        return (
          <IonItem key={r.id} lines="full" button onClick={() => setActive(r)}>
            <IonLabel>
              <h2>{r.name}</h2>
            </IonLabel>
            <IonIcon icon={chevronForward} slot="end" color="tertiary" />
          </IonItem>
        );
      })}
      <PromotionModal
        promotion={active}
        open={!!active}
        onClose={() => setActive(null)}
      />
    </IonList>
  );
}

PromotionList.propTypes = {
  promotions: PropTypes.array,
};

export default PromotionList;
